<template lang="pug">
.course-card-container(@click="onCardClick")
  .row.subject
    h3 {{ courseName }}
    .check(
      :class="checkClass"
      @click.stop='onCheckClick'
      @mouseenter="checkHovered = true"
      @mouseleave="checkHovered = false"
      @mousedown.stop='() => {}'
      @touchstart.stop='() => {}'
    )
  .row.categories
    p.tag(v-for='tag in tags' v-if='tag.name' :style='tag.style') {{ tag.name }}
  .description
    p {{ course.description || 'No description available for this course' }}
  .button(:class="{ planned : planned }" @click.stop="$emit('view')")
    p {{ planned ? 'Added to Your Plan' : 'Learn More'}}
</template>

<script>
export default {
  name : 'course-card',

  props : {
    course  : Object,
    saved   : Boolean,
    planned : Boolean,

    enablePlanning : Boolean
  },

  data() {
    return {
      checkHovered : false,
    };
  },

  computed : {
    courseName() {
      return this.course.name;
    },

    checkClass() {
      return {
        saved   : this.saved && !this.checkHovered,
        planned : this.planned && !this.checkHovered,
        close   : this.checkHovered && ( this.saved || this.planned )
      };
    },

    schoolsArray() {
      const { card } = this;

      if ( !card || !card.schools ) {
        return [];
      }

      const schools = Object.keys( card.schools ).map( key => card.schools[key] );

      return schools;

    },

    displayedSchools() {
      return this.schoolsArray.slice( 0, 6 );
    },

    titleKey() {
      return this.model.title;
    },

    descriptionKey() {
      return this.model.description;
    },

    tags() {
      const { course } = this;
      // Should ideally add specific colors for each tag
      const tags = [
        { name : course.ag, color : '#2E5491' },
        { name : course.honors ? 'Honors' : false, color : '#09B038' },
        { name : course.ncaa ? 'NCAA' : false, color : '#FFA800' },
        { name : course.cte ? 'CTE' : false, color : '#31AD98' }
      ]
        .filter( t => !!t.name )
        .map( tag => ( {
          name  : tag.name,
          style : {
            'background-color' : tag.color,
          }
        } ) );
      return tags;
    },

  },

  methods : {
    onCardClick( e ) {
      if ( this.enablePlanning && !this.planned ) this.$emit( 'plan' );
      else if ( !e.target.className.includes( 'check' ) ) this.$emit( 'view' );
    },

    onCheckClick() {
      if ( this.planned ) this.$emit( 'unplan' );
      else if ( this.saved ) this.$emit( 'unsave' );
      else if ( this.enablePlanning ) this.$emit( 'plan' );
      else this.$emit( 'save' );
    },

    save() {
      this.$emit( 'save' );
    },

    view() {
      this.$emit( 'view' );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.course-card-container {
	// margin: 15px;
	background-color: white;
	padding: 30px 0 0 0;
	font-weight: 300;
	box-shadow: $floatingObject;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	border-radius: 15px;
	overflow: hidden;
	max-height: 500px;
	overflow: hidden;
	position: relative;
	cursor: pointer;
	transition: transform 0.2s ease;

	&:active {
		transform: scale(0.95, 0.95);
	}

	&::after {
		content: ' ';
		position: absolute;
		height: 30px;
		width: 100%;
		left: 0;
		top: calc(100% - 84px); // height of button
		transform: translateY(-100%);
		background-image: linear-gradient( to top, white, rgba(255,255,255,0) );
	}

	.row {
		align-items: center;
		padding: 0 30px;
		flex-shrink: 0;

		&.subject {
			justify-content: space-between;
			text-transform: capitalize;
			margin-bottom: 15px;

			h3 {
				font-size: 24px;
				color: $primary;
				padding-right: 5px;
			}

			i {
				cursor: pointer;
			}
		}

		&.categories {
			flex-wrap: wrap;

			.tag {
				border-radius: 20px;
				padding: 5px 12px;
				font-weight: 400;
				text-transform: uppercase;
				margin: 0px 10px 5px 0px;
				// border: $primaryAccent 2px solid;
				color: white;
				background-color: $primaryAccent;

			}

		}

	}

	.description {
		margin: 10px 0;
		flex: 1 1 auto;
		overflow: hidden;
		padding: 0 30px;

		.label {
			margin: 15px 0 0 0;
			color: lighten( $primary, 15 );
			text-transform: uppercase;
			font-weight: 600;
			font-size: 14px;
			text-align: center;
		}

		.column {
			text-transform: capitalize;
			margin-top: 15px;

			p {
				font-size: 18px;
				margin: 5px 0;

				&:nth-of-type(1){
					margin-top: 0;
				}
			}

			.more {
				color: $primary;
			}
		}
	}

	.button {
		margin-top: 20px;
		text-transform: capitalize;
		color: $primary;
		font-weight: 600;
		border-radius: 0;
		padding: 15px 30px;
		flex-shrink: 0;
		background-color: $secondary;
		transition: background-color 0.3s ease;
		&.planned {
			color: white;
			background-color: $planned;
		}
	}
}
</style>
